import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class AsideBox extends React.PureComponent {
    state = {};
    static propTypes = {};
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */

        return (
            <div className={styles.asideBox}>
                <a href="http://www.ifeng.com/" className={styles.a04} />
                <a href="http://help.ifeng.com/" className={styles.a03} target="_blank" />
            </div>
        );
    }
}

export default errorBoundary(AsideBox);
